/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, { useState, useEffect } from "react";
import Navigation from "./Navigation";
import ModelScene from "./ModelScene";
import useCustomizableContext from "~/CustomizableToolPage/useCustomizableContext";
import useModel3D from "./ModelScene/three/hooks/useModel3D";

interface Props {
  uploadInProgress?: boolean;
}
const ModelViewer = ({ uploadInProgress = false }: Props) => {
  const {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    selectedRegion,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    regionData,
  } = useCustomizableContext();

  const { transitionModelView, loaded } = useModel3D();

  const handleCameraChange = (id: number) => {
    setSelectedCameraRegion(id);
    transitionModelView(regionData![id]!);
  };

  const [selectedCameraRegion, setSelectedCameraRegion] = useState(
    selectedRegion
  );
  const [infoPanelShowing, setInfoPanelShowing] = useState(true);
  const [showModelErrorMessage] = useState(false);

  useEffect(() => {
    setSelectedCameraRegion(selectedRegion);
    transitionModelView(regionData![selectedRegion]!);
  }, [regionData, selectedRegion, transitionModelView]);

  return (
    <div id="model-scene">
      {(!loaded || uploadInProgress) && !showModelErrorMessage && (
        <div className="customize__preloader">
          <div className="customize__preloader-icon" />
        </div>
      )}

      <ModelScene />

      {loaded && (
        <Navigation
          infoPanelShowing={infoPanelShowing}
          setInfoPanelShowing={setInfoPanelShowing}
          selectedCameraRegion={selectedCameraRegion}
          setSelectedCameraRegion={handleCameraChange}
        />
      )}

      <div className={`customize__controls${infoPanelShowing ? " in" : ""}`}>
        {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
        <span
          className="icon customize__controls-close icon-cancel"
          onClick={() => setInfoPanelShowing(false)}
        />
        <div className="customize__controls-title">3d Model Controls</div>

        <div className="customize__controls-block-container">
          <div className="customize__controls-block">
            {/* eslint-disable-next-line jsx-a11y/alt-text */}
            <img
              className="customize__controls-img"
              src="//cdnimg.webstaurantstore.com/uploads/design/2019/10/customize-icon-left-button.png"
            />
            <div className="customize__controls-text">
              <div className="customize__controls-name">Left Button</div>
              <div className="customize__controls-desc">Rotate</div>
            </div>
          </div>
          <div className="customize__controls-block">
            {/* eslint-disable-next-line jsx-a11y/alt-text */}
            <img
              className="customize__controls-img"
              src="//cdnimg.webstaurantstore.com/uploads/design/2019/10/customize-icon-right-button.png"
            />
            <div className="customize__controls-text">
              <div className="customize__controls-name">Right Button</div>
              <div className="customize__controls-desc">Pan</div>
            </div>
          </div>
          <div className="customize__controls-block">
            {/* eslint-disable-next-line jsx-a11y/alt-text */}
            <img
              className="customize__controls-img"
              src="//cdnimg.webstaurantstore.com/uploads/design/2019/10/customize-icon-scroll-wheel.png"
            />
            <div className="customize__controls-text">
              <div className="customize__controls-name">Scroll Wheel</div>
              <div className="customize__controls-desc">Zoom</div>
            </div>
          </div>
        </div>
      </div>
      {false && ( // TODO: remove 'false' and hook this up
        <div className="customize__error">
          <div className="customize__error-content">
            {/* eslint-disable-next-line jsx-a11y/alt-text */}
            <img
              className="customize__error-img"
              src="//cdnimg.webstaurantstore.com/uploads/images/2017/11/web-gl-logo.jpg"
            />
            <div className="customize__error-text">
              <span className="icon icon-attention customize__error-icon" />
              WebGL is required to use this tool. Please enable WebGL in your
              browser for 3d renderings and interaction.
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ModelViewer;
